import React from 'react';

import styles from './MonitoringSummary.module.scss';

export const MonitoringSummary = ({
  data,
  title,
  labels,
}: {
  data: { [key: string]: any };
  title: string;
  labels: { [key: string]: string };
}) => {
  return (
    <div className={styles.stats}>
      <div className={styles.title}>{title}</div>
      {Object.entries(data).map(([key, value]) => (
        <div key={key}>
          <span className={styles.label}>{labels[key]}</span>
          <span className={styles.value}>{value}</span>
        </div>
      ))}
    </div>
  );
};
